/**
 * Naming the thing the user is pointing at, for the AI's context and tool rows.
 *
 * `.type` is a class name on an Object3D or a Material — and a NUMBER on a
 * Texture, where it means the texel data type. Reading it blindly printed
 * `INSPECTING: 1009` (`UnsignedByteType`) as if it were the object's identity,
 * and the session burned six tool calls looking for "resource 1009".
 */

interface NamedTarget {
    readonly name?: unknown;
    readonly type?: unknown;
    readonly constructor?: { name?: string };
}

/** The kind of thing this is: its `type` when that is a name, else its class. */
export function typeNameOfTarget(target: unknown): string {
    const t = target as NamedTarget | null | undefined;
    if (!t) return "object";
    if (typeof t.type === "string" && t.type.trim()) return t.type;
    const className = t.constructor?.name;
    return className && className !== "Object" ? className : "object";
}

/** What to call it: its own name when it has one, else what kind of thing it is. */
export function labelOfTarget(target: unknown): string {
    const t = target as NamedTarget | null | undefined;
    if (!t) return "object";
    if (typeof t.name === "string" && t.name.trim()) return t.name;
    return typeNameOfTarget(target);
}
